import {
  DownloadOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import { ErrorNotificationMsg } from "../../utils/Notifications";

const { Option } = Select;
const ReturnReport = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [DeliveryStatusForm] = Form.useForm();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSuburb, setLoadingSuburb] = useState(false);
  const [deliveryreturn, setdeliveryreturn] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [zones, setZones] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [postalList, setPostalList] = useState(null);
  const [loadingPostal, setLoadingPostal] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // const [DeliveryStatusList, setDeliveryStatusList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [reasonList, setReasonList] = useState([]);
  const formRef = useRef();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const intialFilter = {
    state: "",
    driver_id: "",
    zone_id: [],
    suburb_id: [],
    postcode_name: [],
    reasons: [],
    status: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);

  useEffect(() => {
    const getdeliveryreturn = async () => {
      setLoading(true);

      const queryParamsObject = {
        ...state,
        start_date: startDate || null,
        end_date: endDate || null,
        state: stateFilter?.state || null,
        driver_id: stateFilter?.driver_id || null,
        status: stateFilter?.status || null,
        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      const payload = {
        zone_id: stateFilter?.zone_id || [],
        suburb_id: stateFilter?.suburb_id || [],
        postcode_name: stateFilter?.postcode_name || [],
        reasons: stateFilter?.reasons || [],
      };
      const queryParamsplusfield = `${queryParams}&fields=${"id,parcel_no,hawb,customer_code,customer_name,postcode_name,customer_address,customer_phone,company_name,status,zone_name,suburb_name,state_name,country_name,created_at,package_failed_delivery_status,assigned_to_pickup_driver,assigned_to"}`;
      try {
        const apiResponse = await patchRequest(
          // `return-delivery-report/delivery-report-filter/?${queryParams}`,
          `return-delivery-report/delivery-failed-report/?${queryParamsplusfield}`,
          payload
        );
        if (apiResponse.data.success) {
          setdeliveryreturn(apiResponse.data.data);
          settotalCount(apiResponse.data.count);
        }
      } catch (error) {
        ErrorNotificationMsg(t("Error fetching return delivery report"));
      } finally {
        setLoading(false);
      }
    };

    getdeliveryreturn();
  }, [state, t]);
  // }, [state, startDate, endDate, stateFilter, t]);
  const getDriverName = async () => {
    try {
      const response = await getRequest("employee/drivers-list/");
      const { data } = response.data;
      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);
    } catch (error) {
      console.log("Error fetching driver list:", error);
    }
  };
  const getReasonName = async () => {
    try {
      const response = await getRequest("failed-delivery-status/");
      const { data } = response.data;
      setReasonList(data);
      formRef.current.setFieldsValue(response.data.data);
    } catch (error) {
      console.log("Error fetching driver list:", error);
    }
  };

  useEffect(() => {
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getzoneByState(authUserData()?.state)
      : getzoneByState(1);
    // authUserData()?.zone
    //   ? getSuburbByzone(authUserData()?.zone)
    //   : getSuburbByzone();
    // getDeliveryStatusName();
    getDriverName();
    getReasonName();
  }, []);

  const [checkedList, setCheckedList] = useState([
    "parcel_no",
    "hawb",
    "customer_name",
    "customer_address",
    "status",
    "suburb",
    "postcode",
    "state",
    "zone",
    "assigned_to",
    "package_failed_delivery_status",
    // "driver__email",
    // "driver__phone",
    "created_at",
  ]);

  // const downloadCSV = async () => {
  //   // const endpoint = `return-delivery-report/delivery-report-excel-download/`;
  //   const endpoint = `return-delivery-report/delivery-failed-report-excel-download/`;
  //   const fileType = "csv";

  //   try {
  //     await getRequest(endpoint).then((response) => {
  //       const blob = new Blob([response.data], {
  //         type: "text/csv",
  //       });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `LateReturnReport${+new Date()}.${fileType}`;
  //       link.click();
  //     });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       console.error("File not found or endpoint is incorrect.");
  //     } else {
  //       console.error("Error downloading the file:", error);
  //     }
  //   }
  // };

  const downloadCSV = async () => {
    setBtnLoading(true);
    const endpoint = `return-delivery-report/delivery-failed-report-excel-download/`;
    const fileType = "csv";

    // Construct query parameters
    const queryParamsObject = {
      // ...state,
      start_date: startDate || null,
      end_date: endDate || null,
      state: stateFilter?.state || null,
      driver_id: stateFilter?.driver_id || null,
      status: stateFilter?.status || null,
      // page: state.page,
      ordering: state.ordering,
      // pagesize: state.pagesize,
      search: state.search,
      total: state.total,
    };

    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    // Create payload
    const payload = {
      zone_id: stateFilter?.zone_id || [],
      suburb_id: stateFilter?.suburb_id || [],
      postcode_name: stateFilter?.postcode_name || [],
      reasons: stateFilter?.reasons || [],
    };

    try {
      // Use patchRequest instead of getRequest
      const response = await patchRequest(
        `${endpoint}?${queryParams}`,
        payload
      );

      // Process the downloaded file as CSV
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `LateReturnReport${+new Date()}.${fileType}`;
      link.click();
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        setBtnLoading(false);
      }
    }
  };

  const [columns, setColumns] = useState([
    {
      title: "HAWB",
      dataIndex: "hawb",
      key: "hawb",
      sorter: true,
      width: 50,
    },
    {
      title: "Package No.",
      dataIndex: "parcel_no",
      key: "parcel_no",
      sorter: true,
      width: 50,
    },
    {
      title: "Driver",
      dataIndex: "assigned_to",
      key: "assigned_to",
      sorter: true,
      width: 120,
      render: (assigned_to) => {
        // Check if assigned_to is an object or "unassigned"
        if (typeof assigned_to === "object" && assigned_to !== null) {
          return assigned_to.name; // Render driver's name if it's an object
        }
        if (assigned_to === "unassigned") {
          return "Unassigned"; // Render 'Unassigned' if it's the string 'unassigned'
        }
        return "N/A"; // Fallback in case assigned_to is null or undefined
      },
    },
    {
      title: "Schedule Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: true,
      width: 100,
      render: (text) => (
        // <Tooltip title={text}>
        <div className="text-ellipsis">
          {text ? moment(text, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY") : "-"}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: true,
      width: 100,
    },
    {
      title: "Address",
      dataIndex: "customer_address",
      key: "customer_address",
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
      sorter: true,
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      width: 100,
    },

    {
      title: "Reasons",
      dataIndex: "package_failed_delivery_status",
      key: "package_failed_delivery_status",
      sorter: true,
      width: 400,
      render: (package_failed_delivery_status) => {
        if (
          Array.isArray(package_failed_delivery_status) &&
          package_failed_delivery_status.length > 0
        ) {
          // Join the names of all the reasons with a line break
          return package_failed_delivery_status
            .map((status) => status.name)
            .join(", ")
            .split(", ")
            .map((name, index) => <div key={index}>{name}</div>);
        }
        return "N/A"; // Fallback if the array is empty or not provided
      },
    },

    {
      title: "Suburb",
      dataIndex: "suburb_name",
      key: "suburb",
      sorter: true,
      width: 100,
    },
    {
      title: "Postal Code",
      dataIndex: "postcode_name",
      key: "postcode",
      sorter: true,
      width: 100,
    },

    {
      title: "State",
      dataIndex: "state_name",
      key: "state",
      sorter: true,
      width: 100,
    },
    {
      title: "Run",
      dataIndex: "zone_name",
      key: "zone",
      sorter: true,
      width: 100,
    },

    // {
    //   title: "Driver Email",
    //   dataIndex: "driver_email",
    //   key: "driver__email",
    //   sorter: true,
    //   width: 120,
    // },
    // {
    //   title: "Driver Phone",
    //   dataIndex: "driver_phone",
    //   key: "driver__phone",
    //   sorter: true,
    //   width: 100,
    // },
  ]);
  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="parcel_no">Package No.</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="hawb">HAWB</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="customer_name">Customer Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="customer_address">Address</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="suburb">Suburb</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="postcode">Postal Code</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="state">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="zone">Run</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="assigned_to">Driver</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="package_failed_delivery_status">
                Reasons
              </Checkbox>
            </Col>
            {/* 
            <Col span={12}>
              <Checkbox value="driver__email">Driver Email</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="driver__phone">Driver Phone</Checkbox>
            </Col>{" "}
            */}
            <Col span={12}>
              <Checkbox value="created_at">Schedule Date</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  // const getDeliveryStatusName = async () => {
  //   try {
  //     const response = await getRequest("employee/drivers-list/");
  //     const { data } = response.data;

  //     setDeliveryStatusList(data);
  //     formRef.current.setFieldsValue(response.data.data);
  //   } catch (error) {
  //     // setapiLoading(false);
  //   }
  // };

  // const handleDeliveryStatus = (value) => {

  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     status: value,
  //   }));
  // };

  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );
    setStates(stateResponse?.data?.data);
  };

  const handleStateSelectChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      state: value,
      zone_id: [],
      suburb_id: [],
      postcode_name: [],
    }));
    formRef.current.setFieldsValue({
      zone: undefined,
      suburb: undefined,
      postcode: undefined,
    });
    setZones([]);
    setSuburbList([]);
    setPostalList([]);
    getzoneByState(value);
  };
  const getzoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );
    setZones(zoneResponse?.data?.data);
  };

  const handlezoneChange = (selectedZones) => {
    setStateFilter((prevState) => ({
      ...prevState,
      zone_id: selectedZones,
      suburb_id: [],
      postcode_name: [],
    }));

    formRef.current.setFieldsValue({ suburb: undefined, postcode: undefined });
    setSuburbList([]);
    setPostalList([]);
    // getSuburbByzone(selectedZones);
    getPostalByZone(selectedZones);
  };
  const getSuburbByPostcode = async (postcodeIds) => {
    setLoadingSuburb(true);

    try {
      const payload = { postcode_name: postcodeIds }; // Prepare the payload with zoneId array
      const suburbResponse = await patchRequest(
        "pincode/pincode-by-suburb-filter/?no_pagination=true",
        payload
      );
      if (suburbResponse?.data?.success) {
        setSuburbList(suburbResponse?.data?.data);
        setLoadingSuburb(false);
      }
    } catch {
      ErrorNotificationMsg(t("Error fetching suburb"));
      setLoadingSuburb(false);
    }
  };

  // const handleSuburbChange = (value) => {
  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     suburb_id: value,
  //   }));
  // };
  const handleSuburbChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      suburb_id: value,
      // postcode_name: [],
      // zone: null,
    }));
    // formRef.current.setFieldsValue({ postcode: undefined });
    // setPostalList([]);
    // getPostalBySuburb(value);
  };

  const getPostalByZone = async (zoneIds) => {
    setLoadingPostal(true);
    try {
      const payload = { zone_ids: zoneIds }; // Prepare the payload with zoneId array
      const postalResponse = await patchRequest(
        "zone/zone-by-pincode-filter/?no_pagination=True",
        payload
      );

      if (postalResponse?.data?.success) {
        setPostalList(postalResponse?.data?.data);
        setLoadingPostal(false);
      }
    } catch {
      ErrorNotificationMsg(t("Error fetching postal"));
      setLoadingPostal(true);
    }
  };
  const handlePostalChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      postcode_name: value,
      suburb_id: [],

      // zone: null,
    }));
    formRef.current.setFieldsValue({ suburb: undefined });
    setSuburbList([]);
    getSuburbByPostcode(value);
  };
  const handleReasonsChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      reasons: value,
      // postcode_name: [],
      // zone: null,
    }));
    // formRef.current.setFieldsValue({ postcode: undefined });
    // setPostalList([]);
    // getPostalBySuburb(value);
  };
  const handleDriverChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
      // postcode_name: [],
      // zone: null,
    }));
    // formRef.current.setFieldsValue({ postcode: undefined });
    // setPostalList([]);
    // getPostalBySuburb(value);
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      DeliveryStatusForm.resetFields();
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "parcel_no" && sortOrder === "ascend") {
      sortingEnumKey = "parcel_no";
    }
    if (sortField === "parcel_no" && sortOrder === "descend") {
      sortingEnumKey = "-parcel_no";
    }

    if (sortField === "hawb" && sortOrder === "ascend") {
      sortingEnumKey = "hawb";
    }
    if (sortField === "hawb" && sortOrder === "descend") {
      sortingEnumKey = "-hawb";
    }
    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }
    if (sortField === "assigned_to" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__name";
    }
    if (sortField === "assigned_to" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__name";
    }

    if (sortField === "customer_address" && sortOrder === "ascend") {
      sortingEnumKey = "customer_address";
    }
    if (sortField === "customer_address" && sortOrder === "descend") {
      sortingEnumKey = "-customer_address";
    }

    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb__area";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb__area";
    }

    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode__pincode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode__pincode";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "driver__name" && sortOrder === "ascend") {
      sortingEnumKey = "driver__name";
    }
    if (sortField === "driver__name" && sortOrder === "descend") {
      sortingEnumKey = "-driver__name";
    }
    if (sortField === "driver__email" && sortOrder === "ascend") {
      sortingEnumKey = "driver__email";
    }
    if (sortField === "driver__email" && sortOrder === "descend") {
      sortingEnumKey = "-driver__email";
    }
    if (sortField === "driver__phone" && sortOrder === "ascend") {
      sortingEnumKey = "driver__phone";
    }
    if (sortField === "driver__phone" && sortOrder === "descend") {
      sortingEnumKey = "-driver__phone";
    }
    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }
    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };

  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setEndDate(formattedDate);
  };

  const minEndDate = startDate
    ? moment(startDate, "DD-MM-YYYY").startOf("day")
    : null;

  const handleResetFilter = () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);

    form.setFieldsValue({ search: "" });
    setStartDate(null);
    setEndDate(null);
    setZones([]);
    setSuburbList([]);
    setPostalList([]);
    setZones([]);

    // setStates([]);
    formRef.current.setFieldsValue({
      state: undefined,
      zone: undefined,
      suburb: undefined,
      start_date: undefined,
      end_date: undefined,
      status: undefined,
      postcode: undefined,
      reasons: undefined,
      driver: undefined,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow(selectedRowKeys);
      if (selectedRowKeys.length === 0) {
        DeliveryStatusForm.resetFields();
      }
    },
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow?.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
      if (updatedSelectedRowKeys?.length === 0) {
        DeliveryStatusForm.resetFields();
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow?.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
      if (updatedSelectedRowKeys?.length === 0) {
        DeliveryStatusForm.resetFields();
      }
    },
    selectedRowKeys: selectedRow,
  };

  const colors = ["#737373"];
  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Packages Within The Organization.
                </span>
              }
            > */}
            <h3>{t("Delivery Return Report")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Delivery Return Report")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Package To The Organization&apos;s Database.
                </span>
              }
            ></Tooltip> */}
            {/* <Tooltip title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="customdropdwn"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef} layout="vertical">
                <Space wrap
                      size={[16, 10]}>
                 
                    <Form.Item
                      name="start_date"
                      label={t("pl_min_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_start_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleStartDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("statr_date")}
                        // disabledDate={(current) => current && current < moment().startOf('day')}
                      />
                    </Form.Item>
                
                    <Form.Item
                      name="end_date"
                      label={t("end_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_end_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleEndDateChange}
                        style={{ width: "140px" }}
                        disabled={!startDate} // Disable if start date is not selected
                        placeholder={t("end_date")}
                        disabledDate={(current) =>
                          current && (minEndDate ? current < minEndDate : false)
                        } // Disable dates before selected start date
                      />
                    </Form.Item>
                 
                    <Form.Item
                      name="state"
                      label={t("pl_state")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select state")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        name="state"
                        label={t("pl_state")}
                        placeholder={t("pl_select_state")}
                        value={state.state}
                        onChange={handleStateSelectChange}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "140px" }}
                      >
                        {states.map((state) => (
                          <Option key={state.id} value={state.id}>
                            {state.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                 
                    <Form.Item
                      name="zone"
                      label={t("pl_zone")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select city")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        name="zone"
                        label={t("pl_zone")}
                        placeholder={t("val_zone")}
                        onChange={handlezoneChange}
                        value={state.zone}
                        showArrow
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"

                        // style={{ width: '100%' }} // Optional: adjust width as needed
                      >
                        {zones?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.zone}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                
                    <Form.Item name="postcode" label={t("pl_postal")}>
                      <Select
                        placeholder={t("pl_select_postal")}
                        name="postcode"
                        value={state?.postcode}
                        showArrow
                        onChange={handlePostalChange}
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "120px" }}
                        loading={loadingPostal}
                        disabled={loadingPostal}
                      >
                        {postalList?.map((postal) => (
                          <Option
                            key={postal.postcode_id}
                            value={postal.postcode_name}
                          >
                            {postal.postcode_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
               
                    <Form.Item
                      name="suburb"
                      label={t("pl_suburb")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select suburb")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        placeholder={t("pl_select_subrub")}
                        name="suburb"
                        value={state.suburb}
                        showArrow
                        onChange={handleSuburbChange}
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        loading={loadingSuburb}
                        disabled={loadingSuburb}
                        style={{ width: "170px" }}
                      >
                        {suburbList?.map((suburb) => (
                          <Option
                            key={suburb.suburb_id}
                            value={suburb.suburb_id}
                          >
                            {suburb.suburb_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                 
                    <Form.Item
                      name="driver"
                      label={t("Driver")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select suburb")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        placeholder={t("Select the driver")}
                        name="suburb"
                        value={state.driver}
                        showArrow
                        onChange={handleDriverChange}
                        // mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        // loading={loadingSuburb}
                        // disabled={loadingSuburb}
                        style={{ width: "170px" }}
                      >
                        {driverList?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                 
                    <Form.Item
                      name="reasons"
                      label={t("Reasons")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select suburb")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        placeholder={t("Select the reasons")}
                        name="reasons"
                        value={state.reasons}
                        showArrow
                        onChange={handleReasonsChange}
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        // loading={loadingSuburb}
                        // disabled={loadingSuburb}
                        style={{ width: "200px" }}
                      >
                        {reasonList?.map((reason) => (
                          <Option key={reason.id} value={reason.id}>
                            {reason.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                 
                  {/* <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="status"
                      label={t("delivery_status")}
                      // prefix={<User />}
                      value={state?.status}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: <Trans>{t("val_role")}</Trans>,
                    //   },
                    // ]}
                    >
                      <Select
                        showArrow
                        placeholder={t("pl_delivery_status")}
                        // prefix={<User />}
                        onChange={(value) => handleDeliveryStatus(value)}
                      >
                        <Option key="Not Scanned" value="Not Scanned">
                          Not Scanned
                        </Option>
                        <Option key="Received in Depo" value="Received in Depo">
                          Received in Depo
                        </Option>
                        <Option key="Loaded" value="Loaded">
                          Loaded
                        </Option>
                        <Option key="Delivered" value="Delivered">
                          Delivered
                        </Option>
                        <Option key="Failed" value="Failed">
                          Failed
                        </Option>
                        <Option
                          key="RTS- Return to Sender"
                          value="RTS- Return to Sender"
                        >
                          RTS- Return to Sender
                        </Option>
                        <Option
                          key="RD- Return to depo"
                          value="RD- Return to depo"
                        >
                          RD- Return to depo
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col> */}
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <Button
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    // label="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>
                  {/* </Tooltip> */}
                  {startDate ||
                  endDate ||
                  stateFilter?.state ||
                  stateFilter?.driver_id ||
                  stateFilter?.suburb_id.length !== 0 ||
                  stateFilter?.zone_id.length !== 0 ||
                  stateFilter?.postcode_name.length !== 0 ||
                  stateFilter?.reasons.length !== 0 ? (
                    // <Tooltip title="Reset Filter">
                    <Button
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      // label="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>
                {/* <Tooltip title="Download CSV"> */}
                <Button
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="button"
                  // label="Download CSV"
                  onClick={downloadCSV}
                  loading={btnLoading}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                    CSV
                  </span>
                </Button>
                {/* </Tooltip> */}
              </Space>
            </div>
          </div>
<div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            scroll={{ x: 1800 }}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={deliveryreturn}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
      </div>
    </>
  );
};
export default ReturnReport;
